const PATHS = {
  alert:<path d="M12 3.2 3.4 18.1a1.4 1.4 0 0 0 1.2 2.1h14.8a1.4 1.4 0 0 0 1.2-2.1L12 3.2Zm0 5.4v4.8m0 3.4h.01"/>,
  archive:<path d="M4 7h16M6 7v12h12V7M8 7V5h8v2m-5 5h2"/>,
  arrowIn:<path d="M12 5v14m-6-6 6 6 6-6"/>,
  arrowOut:<path d="M12 19V5m-6 6 6-6 6 6"/>,
  banknote:<path d="M3 6h18v12H3V6Zm4 0a4 4 0 0 1-4 4m14-4a4 4 0 0 0 4 4M7 18a4 4 0 0 0-4-4m14 4a4 4 0 0 1 4-4M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"/>,
  bell:<path d="M18 8a6 6 0 0 0-12 0c0 6-2 7-2 9h16c0-2-2-3-2-9ZM10 20a2 2 0 0 0 4 0"/>,
  bolt:<path d="M13 3 5 14h6l-1 7 8-11h-6l1-7Z"/>,
  book:<path d="M12 6c-2-1.4-4.5-2-8-2v14c3.5 0 6 .6 8 2 2-1.4 4.5-2 8-2V4c-3.5 0-6 .6-8 2Zm0 0v14"/>,
  briefcase:<path d="M9 6V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1m-9 0h10a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Zm8 0H10"/>,
  'more-horizontal':<path d="M5 12h.01M12 12h.01M19 12h.01" strokeWidth="3"/>,
  calendar:<path d="M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Zm2-3v6m10-6v6M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01"/>,
  calculator:<path d="M6 3h12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm2 4h8M8 12h.01M12 12h.01M16 12h.01M8 16h.01M12 16h.01M16 16h.01"/>,
  chart:<path d="M4 19V5m0 14h16M8 16V9m4 7V7m4 9v-4"/>,
  check:<path d="m5 12 4 4L19 6"/>,
  checkCircle:<path d="M22 11.1V12a10 10 0 1 1-5.9-9.1M8 11.5l3 3 9-9"/>,
  chevronDown:<path d="m6 9 6 6 6-6"/>,
  chevronLeft:<path d="m15 6-6 6 6 6"/>,
  gift:<path d="M4 11h16v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9Zm-1-4h18v4H3V7Zm9 0v14M12 7c-1-3-5-4-5-1.5S10 7 12 7Zm0 0c1-3 5-4 5-1.5S14 7 12 7Z"/>,
  undo:<path d="M9 14 4 9l5-5M4 9h10a6 6 0 0 1 0 12h-3"/>,
  redo:<path d="m15 14 5-5-5-5m5 5H10a6 6 0 0 0 0 12h3"/>,
  award:<path d="M12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm-3.5-1-1.5 7 5-3 5 3-1.5-7"/>,
  chevronRight:<path d="m9 6 6 6-6 6"/>,
  chevronUp:<path d="m18 15-6-6-6 6"/>,
  clock:<path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-14v5l3 2"/>,
  code:<path d="m9 8-4 4 4 4m6-8 4 4-4 4"/>,
  compare:<path d="M4 8h16m0 0-3-3m3 3-3 3M20 16H4m0 0 3-3m-3 3 3 3"/>,
  copy:<path d="M9 9h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2Zm-4 6H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v.2"/>,
  cpu:<path d="M7 7h10v10H7V7Zm3 3h4v4h-4v-4ZM9 3v4m6-4v4M9 17v4m6-4v4M3 9h4m-4 6h4m10-6h4m-4 6h4"/>,
  creditCard:<path d="M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Zm-2 5h20M6 15h5"/>,
  database:<path d="M4 6c0 1.7 3.6 3 8 3s8-1.3 8-3-3.6-3-8-3-8 1.3-8 3Zm0 0v6c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 12v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6"/>,
  download:<path d="M12 4v12m0 0 5-5m-5 5-5-5M4 20h16"/>,
  eye:<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Zm10-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"/>,
  eyeOff:<path d="m3 3 18 18M10.6 6.1A10 10 0 0 1 12 6c5 0 9 6 9 6a15 15 0 0 1-3.2 3.7M6.6 6.6C4.3 8.1 3 12 3 12s4 6 9 6a9 9 0 0 0 4.4-1.1M9.9 9.9a3 3 0 0 0 4.2 4.2"/>,
  file:<path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-6-6Zm0 0v6h6M8 13h8M8 17h6"/>,
  flag:<path d="M5 21V4m0 1h11l-2 4 2 4H5"/>,
  filter:<path d="M4 5h16l-6.5 7.3V19l-3 1v-7.7L4 5Z"/>,
  folder:<path d="M3 7a2 2 0 0 1 2-2h4l2 2.5h8a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z"/>,
  gauge:<path d="M4.4 19a9 9 0 1 1 15.2 0H4.4ZM12 15l4-5m-4 5a1.2 1.2 0 1 0 0 .01M7 15h.01M12 7h.01M17 15h.01"/>,
  gitBranch:<path d="M6 3v12m0 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm12-12a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0 6v2a4 4 0 0 1-4 4H6"/>,
  grip:<path d="M9 5h.01M15 5h.01M9 12h.01M15 12h.01M9 19h.01M15 19h.01"/>,
  history:<path d="M3 12a9 9 0 1 0 3-6.7L3 8m0-5v5h5m4-1v5l3 2"/>,
  home:<path d="m4 11 8-7 8 7v8a2 2 0 0 1-2 2h-4v-6h-4v6H6a2 2 0 0 1-2-2v-8Z"/>,
  image:<path d="M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm-1 11 5.5-5 5 4.5L17 12l4 3.5M9 10h.01"/>,
  inbox:<path d="M5 4h14l2 12v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3L5 4Zm-2 12h6l1 2h4l1-2h6"/>,
  info:<path d="M12 17v-5m0-4h.01M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z"/>,
  layers:<path d="m12 3 9 5-9 5-9-5 9-5Zm-7 9 7 4 7-4M5 16l7 4 7-4"/>,
  link:<path d="M10 13a5 5 0 0 0 7.1.1l2-2a5 5 0 0 0-7.1-7.1l-1.1 1.1M14 11a5 5 0 0 0-7.1-.1l-2 2a5 5 0 0 0 7.1 7.1l1.1-1.1"/>,
  list:<path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/>,
  lock:<path d="M6 10V7a6 6 0 0 1 12 0v3M5 10h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Zm7 5v3"/>,
  minus:<path d="M5 12h14"/>,
  monitor:<path d="M4 5h16v10H4V5Zm6 14h4m-6 0h8"/>,
  move:<path d="M12 3v18M3 12h18m-9-9-2.5 2.5M12 3l2.5 2.5M12 21l-2.5-2.5M12 21l2.5-2.5M3 12l2.5-2.5M3 12l2.5 2.5M21 12l-2.5-2.5M21 12l-2.5 2.5"/>,
  network:<path d="M12 6a3 3 0 1 0 0 .01M6 18a3 3 0 1 0 0 .01M18 18a3 3 0 1 0 0 .01M8.5 16l2.2-7M15.5 16l-2.2-7"/>,
  panel:<path d="M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm11 0v14"/>,
  pencil:<path d="M17 3a2.8 2.8 0 0 1 4 4L8 20l-5 1 1-5L17 3Z"/>,
  pin:<path d="M12 17v5M8 3h8l-1 6 3 4H6l3-4z"/>,
  clipboard:<path d="M9 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-3M9 3h6v4H9V3Zm-1 9h8m-8 4h6"/>,
  plus:<path d="M12 5v14M5 12h14"/>,
  pulse:<path d="M2 12h5l2-5 3 10 2-5h8"/>,
  refresh:<path d="M20 11a8 8 0 1 0 2 5.3M20 4v7h-7"/>,
  search:<path d="m21 21-4.3-4.3M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z"/>,
  settings:<path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm0-13v3m0 13v3m8.2-15.2-2.1 2.1M5.9 18.1l-2.1 2.1m17.2-8.2h-3M6 12H3m17.2 8.2-2.1-2.1M5.9 5.9 3.8 3.8"/>,
  sliders:<path d="M5 3v5m0 4v9M12 3v10m0 4v4M19 3v3m0 4v11M2 8h6m1 7h6m1-7h6"/>,
  share:<path d="M8 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm13-6a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM7.9 10.8l8.2-4.1M7.9 13.2l8.2 4.1"/>,
  shield:<path d="M12 3 5 6v5c0 4.4 2.8 8.4 7 10 4.2-1.6 7-5.6 7-10V6l-7-3Z"/>,
  spark:<path d="m13 2-2 7-7 2 7 2 2 7 2-7 7-2-7-2-2-7Z"/>,
  star:<path d="M12 3l2.8 5.8 6.2.9-4.5 4.4 1.1 6.2L12 17.3 6.4 20.3l1.1-6.2L3 9.7l6.2-.9Z"/>,
  table:<path d="M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm-1 4.5h18M9 9.5V19m6-9.5V19"/>,
  target:<path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0-4a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm0-4a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>,
  trash:<path d="M4 7h16M9 7V4h6v3m-9 0 1 14h10l1-14M10 11v6m4-6v6"/>,
  trend:<path d="M3 20h18M4 16l5-5 4 3 7-8m-5 0h5v5"/>,
  upload:<path d="M12 16V4m0 0 5 5m-5-5-5 5M4 20h16"/>,
  user:<path d="M20 21a8 8 0 0 0-16 0M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/>,
  users:<path d="M17 21v-2a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v2m9-15a4 4 0 1 0-8 0 4 4 0 0 0 8 0Zm5 1a4 4 0 0 1 0 8m1 2a5 5 0 0 1 5 5v2"/>,
  warning:<path d="M12 3.2 3.4 18.1a1.4 1.4 0 0 0 1.2 2.1h14.8a1.4 1.4 0 0 0 1.2-2.1L12 3.2Zm0 5.4v4.8m0 3.4h.01"/>,
  workflow:<path d="M5 3h6v6H5V3Zm8 12h6v6h-6v-6ZM8 9v4a4 4 0 0 0 4 4h1m-1-12h6a3 3 0 0 1 3 3v4"/>,
  x:<path d="M18 6 6 18M6 6l12 12"/>,
};

export default function Icon({ name = 'info', size = 16, strokeWidth = 2, style }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display:'inline-block', flexShrink:0, ...style }}
    >
      {PATHS[name] || PATHS.info}
    </svg>
  );
}
